module.exports = __webpack_public_path__ + "static/media/waitlistImg.2f5a3fc8.gif";